import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL } from '../apiConfig'

// export const fetchLTReport = createAsyncThunk(
//   'fetchLTReport',
//   async ({ jwtBearer }) => {
//     const response = await fetch(`${BASE_URL}pipeline/legaltechnical/data/`, {
//       headers: {
//         Authorization: `Bearer ${jwtBearer}` // Include the bearer token in the request header
//       }
//     })
//     return response.json()
//   }
// )
export const fetchLTReport = createAsyncThunk(
  'fetchLTReport',
  async ({ jwtBearer }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}pipeline/legaltechnical/data/`, {
        headers: {
          Authorization: `Bearer ${jwtBearer}`
        }
      });

      if (!response.ok) {
        if (response.status === 401) {
          window.location.reload();
        }
        const errorData = await response.json();
        return rejectWithValue(errorData);
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const LTReportSlice = createSlice({
  name: 'LTReports',
  initialState: {
    isLoading: false,
    data: null,
    isError: false
  },
  extraReducers: builder => {
    builder.addCase(fetchLTReport.pending, (state, action) => {
      state.isLoading = true
    })
    builder.addCase(fetchLTReport.fulfilled, (state, action) => {
      state.isLoading = false
      state.data = action.payload
    })
    builder.addCase(fetchLTReport.rejected, (state, action) => {
      console.log('Error', action.payload)
      state.isError = true
    })
  }
})

export default LTReportSlice.reducer
